export const HOME = {
  heroSection: 'home-hero-section',
  shopNowBtn: 'home-shop-now-btn',
  featuredProducts: 'home-featured-products',
  emergentLink: 'emergent-link',
};

export const NAV = {
  logo: 'nav-logo',
  homeLink: 'nav-home-link',
  productsLink: 'nav-products-link',
  offersLink: 'nav-offers-link',
  aboutLink: 'nav-about-link',
  contactLink: 'nav-contact-link',
  cartBtn: 'nav-cart-btn',
  accountBtn: 'nav-account-btn',
  loginBtn: 'nav-login-btn',
  logoutBtn: 'nav-logout-btn',
};

export const PRODUCTS = {
  grid: 'products-grid',
  searchInput: 'products-search-input',
  categoryFilter: 'products-category-filter',
  sortSelect: 'products-sort-select',
  productCard: 'product-card',
};

export const PRODUCT_DETAIL = {
  image: 'product-detail-image',
  name: 'product-detail-name',
  price: 'product-detail-price',
  colorSelect: 'product-color-select',
  sizeSelect: 'product-size-select',
  addToCartBtn: 'product-add-to-cart-btn',
  buyNowBtn: 'product-buy-now-btn',
  whatsappBtn: 'product-whatsapp-btn',
};

export const CART = {
  drawer: 'cart-drawer',
  itemList: 'cart-item-list',
  subtotal: 'cart-subtotal',
  deliveryFee: 'cart-delivery-fee',
  total: 'cart-total',
  checkoutBtn: 'cart-checkout-btn',
  clearBtn: 'cart-clear-btn',
};

export const CHECKOUT = {
  form: 'checkout-form',
  nameInput: 'checkout-name-input',
  phoneInput: 'checkout-phone-input',
  addressInput: 'checkout-address-input',
  paymentMethod: 'checkout-payment-method',
  submitBtn: 'checkout-submit-btn',
};

export const AUTH = {
  loginForm: 'auth-login-form',
  registerForm: 'auth-register-form',
  emailInput: 'auth-email-input',
  passwordInput: 'auth-password-input',
  nameInput: 'auth-name-input',
  phoneInput: 'auth-phone-input',
  submitBtn: 'auth-submit-btn',
  switchModeBtn: 'auth-switch-mode-btn',
};

export const ACCOUNT = {
  dashboard: 'account-dashboard',
  ordersTab: 'account-orders-tab',
  profileTab: 'account-profile-tab',
  ordersList: 'account-orders-list',
};

export const ADMIN = {
  dashboard: 'admin-dashboard',
  productsTab: 'admin-products-tab',
  ordersTab: 'admin-orders-tab',
  addProductBtn: 'admin-add-product-btn',
  productForm: 'admin-product-form',
  ordersList: 'admin-orders-list',
};

export const CHATBOT = {
  fab: 'chatbot-fab',
  dialog: 'chatbot-dialog',
  messageInput: 'chatbot-message-input',
  sendBtn: 'chatbot-send-btn',
  messageList: 'chatbot-message-list',
};
